import { Translations } from '../translations.type';

const ko: Translations = {
  lang: '한국어',
  app_title: 'Mahjong BTI',
  app_subtitle: '마작 성격 유형 진단',
  app_description:
    '16가지 마작 성격, 12개의 빠른 질문. 패를 잡았을 때 당신이 어떤 플레이어인지 알아보세요.',
  home_cta_start: '진단 시작',
  home_footnote: '약 2분 · 12문항',

  wizard_progress: (current: number, total: number) =>
    `${total}문항 중 ${current}번째`,
  wizard_prev: '이전',
  wizard_next: '다음',
  wizard_finish: '결과 보기',
  wizard_pick_hint: '자신과 가장 가까운 선택지를 골라주세요',

  loading_messages: [
    '답변을 분석하는 중...',
    '버린 패를 읽는 중...',
    '패를 세는 중...',
    '당신의 유형을 확정하는 중...',
  ],

  result_title: '당신은',
  result_subtitle: '당신의 마작 성격',
  result_retake: '다시 진단하기',
  result_share: '공유',
  result_share_text: (code: string, name: string) =>
    `저는 ${code} — "${name}"입니다. 당신의 마작 성격은?`,
  result_axes_heading: '당신의 네 가지 축',

  share_button: '공유',
  share_title: 'Mahjong BTI 공유',
  share_link_label: '링크',
  share_copy: '링크 복사',
  share_copied: '복사되었습니다!',
  share_close: '닫기',
  share_scan_hint: '또는 QR 코드를 스캔하세요',
  share_via: '공유',
  share_native: '공유…',
  share_default_text:
    'Mahjong BTI — 12문항으로 알아보는 나의 마작 성격.',
  share_on: (network: string) => `${network}에 공유`,

  footer_author: '제작자',
  footer_source: '소스',

  axis_AD: '공격 — 수비',
  axis_BS: '큰 손 — 작은 손',
  axis_CF: '계산 — 직감',
  axis_TW: '신중 — 자유',

  axis_AD_tagline: '승부처에서 앞으로 나아가나요, 뒤로 물러서나요?',
  axis_BS_tagline: '한 방의 큰 불꽃, 아니면 스무 번의 작은 승리?',
  axis_CF_tagline: '숫자가 결정하나요, 직감이 결정하나요?',
  axis_TW_tagline: '계획을 지키나요, 흐름에 맡기나요?',

  pole_A: '공격',
  pole_D: '수비',
  pole_B: '큰 손',
  pole_S: '작은 손',
  pole_C: '계산',
  pole_F: '직감',
  pole_T: '신중',
  pole_W: '자유',

  pole_A_description:
    '패 섞는 소리만 들어도 눈빛이 달라집니다. 손 안의 패는 기념품이 아니라 발사할 탄환. 다음 판은 내 것이라 진심으로 믿으며 거침없이 승부를 겁니다. 인내는 자기 손을 믿지 못하는 사람의 몫이지, 당신과는 거리가 멉니다.',
  pole_D_description:
    '한 판도 못 이기더라도 큰 실점만은 절대 사양. 버린 패를 찻잎 점 읽듯 살피고, 어설픈 모양은 망설임 없이 무너뜨리며, 다른 사람들끼리 부딪치는 동안 조용히 벽 뒤에 앉아 있습니다. 점수도 멘탈도 수면 시간도 무사히 지켜냅니다.',
  pole_B_description:
    '싸구려 승리로는 만족하지 못합니다. 완성된 모양을 깨서라도, 다음 날 아침까지 회자될 만한 큰 손을 노립니다. 이길 거라면 사진 한 장은 남길 만한 손이어야 하고, 가능하면 짧은 수상 소감도 함께.',
  pole_S_description:
    '작게, 자주, 계속 이깁니다. 폭죽은 필요 없어요. 필요한 건 꾸준한 화료와 조금씩 쌓이는 점봉. 점수표에서 작은 손이라고 깎이지 않는데, 굳이 야근할 이유가 없습니다.',
  pole_C_description:
    '버린 패는 데이터, 대기는 확률, 탁자는 당신이 풀고 있는 라이브 스프레드시트. 운은 믿지 않고 장기 기대값을 믿으며, 장기적으로는 평균이 당신 편입니다. 분산은 그저 날씨일 뿐.',
  pole_F_description:
    '왠지 싫은 패, 왠지 좋은 패 — 그 감각을 부정하기를 그만뒀습니다. 예감과 분위기, "이건 아니야"라는 조용한 확신으로 움직이는데, 우주가 이상하게도 자꾸 편을 들어줍니다. 회의론자는 패나 세고 있으세요. 당신은 계속 이길 거니까.',
  pole_T_description:
    '한 번 정한 방침과 끝까지 갑니다. 분위기에 휩쓸려 끊지 않고, 새벽 한 시에 영웅 행세도 하지 않습니다. 규율은 멋없어 보이지만, 점수를 정산할 때가 되면 탁자에서 가장 멋진 것이 바로 그 규율임이 조용히 드러납니다.',
  pole_W_description:
    '계획은 참고용일 뿐, 감옥의 창살이 아닙니다. 흐름이 오면 올라타고, 바람이 바뀌면 같이 꺾습니다. 탁자의 공기가 당신을 운전하죠. 읽히는 플레이? 당신과는 거리가 멉니다 — 가끔은 자기 자신도 못 읽는데, 그게 또 묘미입니다.',

  questions: {
    q1: {
      question: '첫 순, 패를 한 장 가져왔습니다. 당신은:',
      options: [
        '시작이다 — 바로 손 모양을 잡아간다.',
        '서두르지 않는다. 다른 사람들의 버림패를 먼저 본다.',
      ],
    },
    q2: {
      question: '상대가 명백히 화료 직전, 게다가 손도 커 보입니다. 당신은:',
      options: [
        '경쟁한다 — 내 손도 빠르다.',
        '수비로 전환. 쏘아주지 않는다.',
      ],
    },
    q3: {
      question: '마지막 순, 한 장만 더 들어오면 화료지만 대기 패가 위험합니다. 당신은:',
      options: [
        '승부패를 끊고 화료를 노린다.',
        '안전패를 끊는다. 못 이기더라도 실점은 피한다.',
      ],
    },
    q4: {
      question: '지금 작은 손으로 빠르게 화료할 수 있지만, 모양을 깨면 큰 손의 기회가 있습니다. 당신은:',
      options: [
        '모양을 깬다 — 큰 손은 기다릴 가치가 있다.',
        '이긴다. 어떤 화료든 화료다.',
      ],
    },
    q5: {
      question: '큰 손의 핵심이 될 만한 패를 가져왔습니다. 당신은:',
      options: [
        '그 패를 축으로 손을 키운다. 이번 판은 크게.',
        '기억은 해두되, 효율 우선으로 계속 친다.',
      ],
    },
    q6: {
      question: '당신이 꿈꾸는 마작 한 판의 모습은:',
      options: [
        '뿌듯하고 자랑할 만한 큰 손.',
        '하룻밤에 스무 번의 작은 화료.',
      ],
    },
    q7: {
      question: '어떤 패를 끊을지 결정할 때, 주로 의지하는 것은:',
      options: [
        '패를 세고, 버림패를 읽고, 확률을 따진다.',
        '직감. 맞는 패는 그냥 느낌이 온다.',
      ],
    },
    q8: {
      question: '지독한 연패에 빠졌습니다. 해결책은:',
      options: [
        '플레이를 복기하고 전략을 조정한다.',
        '자리를 바꾸고, 손을 씻고, 행운의 부적을 다시 잡는다.',
      ],
    },
    q9: {
      question: '누군가 흔치 않은 대기를 선언했습니다. 당신은:',
      options: [
        '"확률적으로 안전패는 X, Y, Z."',
        '"저 패, 뭔가 느낌이 안 좋다. 끊지 말자."',
      ],
    },
    q10: {
      question: '한 판의 방침을 정했습니다. 중간에:',
      options: [
        '방침을 지킨다 — 규율이 장기적으로 이긴다.',
        '유연하게 바꾼다. 탁자가 변하면 나도 변한다.',
      ],
    },
    q11: {
      question: '탁자에 앉는 이유는:',
      options: [
        '진지하게 친다. 목표는 이기는 것.',
        '재미. 이기면 덤.',
      ],
    },
    q12: {
      question: '내리 세 판을 이긴 뒤, 당신은:',
      options: [
        '여기까지 끌고 온 집중된 스타일을 그대로 유지한다.',
        '긴장을 풀고 흐름에 올라타 과감하게 시도한다.',
      ],
    },
  },

  types: {
    ABCT: {
      name: '도룡도',
      tagline: '냉정, 정밀, 치명적 — 탁자 위의 암살자.',
      description:
        '외과 수술 같은 공격을 펼칩니다. 모든 끊는 패는 계산되어 있고, 모든 밀어붙임은 타이밍이 정확합니다. 마무리에 들어가면 빗나가지 않습니다. 당신이 조용할수록 탁자는 더 위험합니다.',
    },
    ABCW: {
      name: '도박의 신',
      tagline: '큰 손, 큰 베팅, 큰 존재감.',
      description:
        '화려하게, 이기기 위해 칩니다. 탁자의 흐름을 읽고 승부처를 정확히 짚어 눈 하나 깜빡이지 않고 크게 휘두릅니다. 스타일 점수도 덤으로 챙깁니다.',
    },
    ABFT: {
      name: '버서커',
      tagline: '밀고, 밀고, 또 민다. 두려움은 나중에.',
      description:
        '인내는 과대평가됐습니다. 공격적으로 손을 만들고, 공격적으로 밀어붙이며, 직감에 자신을 맡깁니다. 성공하면 짜릿하고, 안 되면 다음 판으로 넘어갈 뿐.',
    },
    ABFW: {
      name: '신비주의자',
      tagline: '운이 지켜주고, 감각이 움직인다.',
      description:
        '공격하지만, 진짜 전략은 "믿는 것". 느낌으로 패를 움직이는데, 우주가 또 그걸 받아줍니다. 회의론자는 운이라 부르고, 당신은 파장이 맞았다고 부르지요.',
    },
    ASCT: {
      name: '컨베이어 장인',
      tagline: '울 수 있으면 울고, 이길 수 있으면 이긴다.',
      description:
        '우아함보다 효율. 가져올 수 있으면 가져오고, 작은 손도 깔끔하게, 또 깔끔하게 — 반복해서 화료해냅니다.',
    },
    ASCW: {
      name: '스피드 암살자',
      tagline: '여섯 순에 이미 들을 자세.',
      description:
        '아주 빠릅니다. 다른 사람들이 손을 정리하고 있을 때 당신은 이미 대기 중. 점수는 크지 않아도 가장 먼저, 그것도 여러 번 화료합니다.',
    },
    ASFT: {
      name: '만족파',
      tagline: '작은 화료도 화료다.',
      description:
        '분위기를 읽고 점봉을 챙깁니다. 폭죽은 필요 없고, 조용하고 반복되는 승리가 가장 편안합니다. 멈출 때를 아는 것도 훌륭한 재능이지요.',
    },
    ASFW: {
      name: '소소화료 챔피언',
      tagline: '하룻밤 스무 번, 전부 최저점.',
      description:
        '밤새 이깁니다 — 최소 점수, 최대 미소. 손의 크기는 아무래도 좋고, "화료!"라고 외칠 수 있는 그 순간이 좋습니다. 어느 탁자에서나 마스코트.',
    },
    DBCT: {
      name: '능구렁이',
      tagline: '이기지도, 쏘아주지도 않는데 결국 이긴다.',
      description:
        '탁자에 녹아들어 존재감을 지웁니다. 화료를 쫓지 않고 생존을 노립니다. 끝나고 보면 점봉은 조용히 당신 쪽에 쌓여 있는데, 아무도 그 이유를 모릅니다.',
    },
    DBCW: {
      name: '역지사지의 매복자',
      tagline: '수비하다… 수비하다… 갑작스러운 기습!',
      description:
        '열 순을 지키고 한 순에 몰아칩니다. 읽히지 않는다는 것이 무기 — 상대가 당신을 읽기를 포기하는 그 순간 정확히 칼을 꺼냅니다.',
    },
    DBFT: {
      name: '조용한 부자',
      tagline: '말은 적게, 손은 크게.',
      description:
        '시끄럽게 굴지 않고 큰 손을 완성합니다. 공격적으로 보일 필요가 없어요 — 선언할 즈음이면 손은 이미 충분히 큽니다. 드라마는 적게, 점수는 많게.',
    },
    DBFW: {
      name: '선의 대가',
      tagline: '흔들리지 않는 자에게 행운은 미소 짓는다.',
      description:
        '이김도 짐도 흘러가는 구름. 담담하게 치다 보면 어쩐 일인지 좋은 패가 알아서 찾아옵니다. 탁자는 당신의 명상실.',
    },
    DSCT: {
      name: '계산기',
      tagline: '확률이 당신의 사랑 표현법.',
      description:
        '모든 대기의 확률, 남은 패의 수, 모든 한 수의 기대값을 압니다. 매번 이기지는 못해도 매번 옳은 선택을 합니다 — 그리고 장기적으로는 당신이 이깁니다.',
    },
    DSCW: {
      name: '신중한 모험가',
      tagline: '먼저 계산, 그다음에 용기.',
      description:
        '리스크를 지고 싶긴 합니다, 정말로 — 다만 숫자를 먼저 확인하고요. 그래서 조심스럽고, 가끔은 모두를 놀라게 합니다. 가끔은 자기 자신까지도.',
    },
    DSFT: {
      name: '안전제일',
      tagline: '수비도 완성된 전략이다.',
      description:
        '목표는 간단합니다 — 쏘아주지 않는 것. 생존을 최우선으로 일찍 접고 폭풍을 비켜갑니다. 모두가 점수를 잃는데 당신만 무사하다면, 이미 이긴 셈입니다.',
    },
    DSFW: {
      name: '게으른 챔피언',
      tagline: '간식 먹으러 왔습니다. 친 김에 치죠.',
      description:
        '마작은 곁들임, 친구가 메인. 느슨하게 치고, 자주 웃고, 점수표에는 눈길도 주지 않습니다. 솔직히 이것도 일종의 경지입니다.',
    },
  },
};

export default ko;
